import { axiosPost } from './axiosPost';
import { axiosPut } from './axiosPut';
import { devError } from './devLog';

const handleApiResponse = (
  response,
  setRefreshCollections,
  refreshCollections,
  setShowModal,
) => {
  if (response.status === 200) {
    if (response.data) {
      setRefreshCollections(!refreshCollections);
      setTimeout(() => {
        setShowModal(false);
      }, 1000);
    } else {
      devError('Response data is missing or not in the expected format.');
    }
  } else {
    devError('Unexpected status:', response.status);
  }
};

export const handleConfirmSelect = async (
  rowId,
  apiIdentifier,
  setRefreshCollections,
  refreshCollections,
  setShowModal,
  triggerNominationStateRefresh,
) => {
  try {
    if (typeof rowId === 'string') {
      let response;

      if (apiIdentifier === 'nomination-drafts' && rowId.includes('d')) {
        const draftNominationRowId = parseInt(rowId.replace(/d/g, ''));

        response = await axiosPut(`${apiIdentifier}/${draftNominationRowId}`, {
          data: {
            publishedAt: null,
          },
        });
      } else if (!rowId.includes('d') && apiIdentifier) {
        response = await axiosPost(apiIdentifier, { data: { rowId } });
      }

      if (response) {
        handleApiResponse(
          response,
          setRefreshCollections,
          refreshCollections,
          setShowModal,
        );

        if (
          apiIdentifier === 'nomination-withdraw' &&
          triggerNominationStateRefresh
        ) {
          triggerNominationStateRefresh(rowId);
        }
      }
    }
  } catch (error) {
    devError('Error occurred:', error);
  }
};
